import { toDriveDirectUrl } from "@/lib/utils";

export interface Noticia {
  id: number;
  titulo: string;
  extracto?: string;
  imagen?: string;
  fecha?: string;
  comuna?: string;
  categoria?: string;
  segmento?: string;
  subtitulo?: string;
}

export interface Cita {
  id: number;
  texto: string;
  autor?: string;
  cargo?: string;
  sector?: string;
  fecha?: string;
  likes?: number;
  avatar?: string;
}

export interface NewsQuoteCardProps {
  cita?: Cita;
  noticia?: Noticia;
}

export default function NewsQuoteCard({ cita, noticia }: NewsQuoteCardProps) {
  if (!cita || !noticia) {
    return (
      <div className="relative rounded-2xl overflow-hidden shadow-md bg-masmed-gray-100 min-h-[480px] md:min-h-[520px] lg:min-h-[560px] flex items-center justify-center">
        <div className="text-masmed-gray-400 text-sm">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-200 group">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={toDriveDirectUrl(noticia.imagen || "")}
          alt={noticia.titulo}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full p-5 md:p-6 lg:p-7 min-h-[480px] md:min-h-[520px] lg:min-h-[560px]">
        {/* Título noticia arriba izquierda */}
        <div className="flex items-start gap-2 mb-auto">
          <div className="w-1 h-10 bg-primary rounded-full flex-shrink-0 mt-0.5" />
          <h3 className="text-white text-sm md:text-base leading-snug"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            {noticia.titulo}
          </h3>
        </div>

        {/* Centro: foto, nombre, fecha, cita */}
        <div className="flex flex-col items-center text-center mt-4">
          {/* Avatar grande */}
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-full border-[3px] border-primary p-0.5">
            <img
              src={toDriveDirectUrl(cita.avatar || "")}
              alt={cita.autor}
              className="w-full h-full rounded-full object-cover"
            />
          </div>

          {/* Nombre */}
          <p className="text-white text-sm md:text-base mt-3 md:mt-4"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
            {cita.autor}
          </p>

          {/* Fecha */}
          <p className="text-white/70 text-xs mt-0.5">
            {cita.fecha}
          </p>

          {/* Línea naranja */}
          <div className="w-10 h-0.5 bg-primary rounded-full mt-3 md:mt-4" />

          {/* Cita */}
          <p className="text-white/90 text-sm leading-relaxed mt-3 md:mt-4 max-w-[260px]">
            {cita.texto}
          </p>
        </div>
      </div>
    </div>
  );
}